const observeStore = (store, select, onChange) => {
  let currentState;

  function handleChange() {
    const nextState = select(store.getState());
    if (nextState !== currentState) {
      currentState = nextState;
      onChange(currentState);
    }
  }

  const unsubscribe = store.subscribe(handleChange);
  handleChange();
  return unsubscribe;
};

// Permit currentState to be set from the actual store instead of being undefined at first.
// This eliminates an unnecessary initial firing of handleChange() when there is no actual state change.
export function initObserveStore(store, select) {
  let currentState = select(store.getState());
  return function observeReduxStore(onChange) {
    function handleChange() {
      const nextState = select(store.getState());
      if (nextState !== currentState) {
        currentState = nextState;
        onChange(currentState);
      }
    }
    const unsubscribe = store.subscribe(handleChange);
    handleChange();
    return unsubscribe;
  };
}
export default observeStore;
